import { render, staticRenderFns } from "./GuidelineBox.vue?vue&type=template&id=5c9c1808&lang=true"
import script from "./GuidelineBox.vue?vue&type=script&lang=js"
export * from "./GuidelineBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports